<template>
  <div class="story">
    <div class="story__header">
      <h4>фотоистория</h4>
      <h3>
        <span class="bullet" :style="{'background-color': bgColor}"></span>
        <span v-html="title"></span>
      </h3>
      <sharing
        :enabled="sharing"
        class="g-visible-tablet"
      />
      <a :href="backlinkComputed" class="story__close"></a>
    </div>
    <transition-group name="fade">
      <div v-for="(item, index) in storyData"
           class="story__item-wrap"
           :key="item.title + index"
           v-show="index === currentSlide || isTablet"
      >
        <div class="story__item">
          <div class="story__item-visual">
            <div v-if="item.image" class="story__item-image">
              <img :src="item.image" alt="" v-bind="imageDisable ? { 'data-disabled-interactive': '' } : {}">
            </div>
            <div
              v-else-if="item.imagesArray"
              class="story__gallery"
            >
              <story-gallery
                :images-array="item.imagesArray"
                :current-slide="currentSlide"
                :image-disable="imageDisable"
              />
            </div>
            <p>{{ item.imageCaption }}</p>
          </div>
          <div class="story__item-text" :style="{'background-color': bgColor}">
            <div class="story__item-text-inner">
              <h2 v-html="item.title"></h2>
              <div v-html="item.text"></div>
            </div>
          </div>
        </div>
      </div>
    </transition-group>
    <template v-if="storyData">
      <div class="story__nav" v-if="!isTablet && storyData.length > 1">
        <div class="story__controls">
          <span @click="showPrev" :class="[{'_disabled': currentSlide === 0}]">
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 0V4V8L0 4L8 0Z" fill="#FFFFFF"/>
            </svg>
          </span>
          <span @click="showNext" :class="[{'_disabled': this.currentSlide === (this.storyData.length - 1)}]">
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0V4V8L8 4L0 0Z" fill="#FFFFFF"/>
            </svg>
          </span>
        </div>
        <div class="story__pagination">
          {{ currentSlide + 1 }} / {{ storyData.length }}
        </div>
        <sharing
          :enabled="sharing"
          alt-direction
          class="g-hidden-tablet"
        />
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'Story',
  components: {
    StoryGallery: () => import('../components/StoryGallery.vue'),
    Sharing: () => import('../components/Sharing.vue'),
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    bgColor: {
      type: String,
      default: '',
    },
    storyData: {
      type: Array,
      default: () => []
    },
    backlink: {
      type: String,
      default: ''
    },
    pageUrl: {
      type: String,
      default: '',
    },
    imageDisable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentSlide: 0,
      sharing: []
    }
  },
  computed: {
    isTablet: function () {
      return this.$vssWidth < 1024
    },
    backlinkComputed: function () {
      return decodeURIComponent(
        (location.search
            .replace('?', '')
            .split('&')
            .map((el) => el.split('='))
            .filter((el) => el.includes('back'))[0]
          ?? [])[1]
        ?? this.backlink);
    },
  },
  async mounted() {

    window.onpopstate = (e) => {
      const val = +e.state?.currentSlideId;

      if (val) {
        this.currentSlide = val;
      }
    }
  },
  methods: {
    showNext() {
      this.currentSlide = this.currentSlide < (this.storyData.length - 1) ? (this.currentSlide + 1) : this.currentSlide;
      this.historyPush(this.pageUrl + '?story=' + this.storyData[this.currentSlide].id);
    },
    showPrev() {
      this.currentSlide = this.currentSlide > 0 ? (this.currentSlide - 1) : 0;
      this.historyPush(this.pageUrl + '?story=' + this.storyData[this.currentSlide].id);
    },
    historyPush(page) {
      window.history.pushState({
        currentSlideId: this.currentSlide,
      }, `${page}`, page)
    },
  },
  async created() {
    const { data } = await window.BX.ajax.runAction('dalee:sharing.sharing.getEnabled');
    this.sharing = data;

    const params = (new URL(document.location)).searchParams;

    const exhibit = +(params.get("story"));
    if (exhibit) {
      this.currentSlide = this.storyData.findIndex(({id}) => exhibit === id);
    }
  },
}
</script>
